// extracted by css-extract-rspack-plugin
export default {"wrapper":"index__wrapper__SDkZi"};